export default {
  picks: {
    imageImport: {
      dropzoneBody: "Importa una foto e prenderemo noi le scelte per te.",
      dropzoneCta: "Clicca qui o trascina e rilascia per caricare",
      preparingResults: "Preparazione risultati",
      adding: "Aggiunta...",
      importedPicks: "Scelte importate",
    },
    actions: {
      findTrends: "Trova trend",
    },
    labels: {
      sgpPricingUnavailable: "Prezzo SGP non disponibile",
    },
    plusPromo: {
      description: "Accedi a giocate avanzate e insight più profondi",
    },
  },
};
